import { render, staticRenderFns } from "./PreviewProductModal.vue?vue&type=template&id=3f5b9f20&scoped=true&"
import script from "./PreviewProductModal.vue?vue&type=script&lang=js&"
export * from "./PreviewProductModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProductModal.vue?vue&type=style&index=0&id=3f5b9f20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b9f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5b9f20')) {
      api.createRecord('3f5b9f20', component.options)
    } else {
      api.reload('3f5b9f20', component.options)
    }
    module.hot.accept("./PreviewProductModal.vue?vue&type=template&id=3f5b9f20&scoped=true&", function () {
      api.rerender('3f5b9f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/PreviewProductModal.vue"
export default component.exports